import "./kendo-drawing.js";
import {
    drawText,
    getFontFaces,
    drawDOM
} from "@progress/kendo-drawing";

window.kendo.drawing = window.kendo.drawing || {};

(function($) {

    var kendo = window.kendo;
    var drawing = kendo.drawing;

    drawing.drawDOM = function(element, options) {
        if (typeof options?.template === "string") {
            options.template = kendo.template(options.template);
        }

        let promise = drawDOM($(element)[0], options);
        return kendo.convertPromiseToDeferred(promise);
    };

    // Aliases used by spreadsheet/print.js
    drawing.drawDOM.drawText = drawText;
    drawing.drawDOM.getFontFaces = getFontFaces;

})(window.kendo.jQuery);
